import api from './api';

const adminDashboardService = {
  /**
   * Get dashboard statistics
   */
  getDashboardStats: async () => {
    const response = await api.get('/auth/admin/dashboard/stats/');
    return response.data;
  },
};

export default adminDashboardService;
